export const routes = {
    root: '/',
    home2: '/home',
    blog: '/blog',
    teamMembers: '/blog/team-members',
    sharath: '/blog/sharath',
    homeschool: '/homeschool',
    learn: '/learn',
    activities: '/activities',
    pdSupport: '/pd-support',
    library: '/learn/library',
    yoga: '/learn/yoga',
    hathaYoga: '/learn/yoga/hatha-yoga',
    nadaYoga: '/learn/yoga/nada-yoga',
    bhakthiYoga: '/learn/yoga/bhakthi-yoga',
    culturalArts: '/learn/cultural-arts',
    softwaresystems: '/softwaresystems',
    experiences: '/blog/our-experiences',
    wayOfLife: '/blog/way-of-life',
    initiatives: '/initiatives',
    u2l: '/u2l',
    contact: '#contactUs',
    instagramProfile: "https://www.instagram.com/swadharmaspandana/",
    linkedInProfile: "https://linkedin.com/company/swadharma-spandana/"
}
